import { Modal } from '@gerdau/hefesto/Modal';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { useHistory } from 'react-router-dom';
import { getTaggingInformationScreen } from '../../../../../utils/Tagging';

interface IContractWithoutConstructions {
  cleanConstructionIdentificationState: () => void;
  goToConstructionRegistration: () => void;
}

const ContractWithoutConstructions: React.FC<IContractWithoutConstructions> = ({
  cleanConstructionIdentificationState,
  goToConstructionRegistration
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(
      sendTagging({
        page: history.location.pathname,
        screenName,
        event: 'page_view'
      })
    );
  }, []);

  const { screenName, itemDescription } = getTaggingInformationScreen(
    'modal_contract_without_constructions'
  );

  return (
    <Modal
      title="Para realizar pedidos neste contrato, finalize o cadastro da obra."
      onClose={() => {
        cleanConstructionIdentificationState();
      }}
      buttons={{
        left: {
          children: 'Cancelar',
          name: 'cancelButton',
          onClick: () => {
            dispatch(
              sendTagging({
                screenName,
                itemName: 'button:cancelar',
                event: 'click',
                itemDescription: `${itemDescription}_cancelar`
              })
            );
            cleanConstructionIdentificationState();
          },
          type: 'button'
        },
        right: {
          children: 'Sim',
          name: 'confirmButton',
          onClick: () => {
            dispatch(
              sendTagging({
                screenName,
                itemName: 'button:sim',
                event: 'click_filter',
                itemDescription: `${itemDescription}_sim`
              })
            );
            goToConstructionRegistration();
          },
          type: 'button'
        }
      }}
    >
      Deseja finalizar o cadastro agora?
    </Modal>
  );
};

export default ContractWithoutConstructions;
